const STATUS_TYPES = {
  CUSTOMER: 0,
  ATL: 1,
  ATM: 2,
  ATL_OBSERVER: 3,
  ATM_OBSERVER: 4
};

export default STATUS_TYPES;
